import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../components/BenefitBanner/components/Container.js';
import { Header } from '../../components/BenefitBanner/components/Header.js';
import { Item } from '../../components/BenefitBanner/components/Item/index.js';
import { List } from '../../components/BenefitBanner/components/List.js';
export const BenefitBanner = ({
  short = false,
  headline,
  backgroundColor,
  benefits,
  columns = 3,
  ...restProps
}) => _jsxs(Container, {
  ...restProps,
  backgroundColor: backgroundColor,
  spacing: 2,
  alignItems: "center",
  children: [_jsx(Header, {
    children: _jsx("span", {
      children: headline
    })
  }), _jsx(List, {
    short: short,
    itemsPerRow: columns,
    children: benefits.map(({
      title,
      keyfact,
      description,
      iconUrl
    }, index) => _jsx(Item, {
      title: title,
      description: description,
      iconUrl: iconUrl,
      keyfact: keyfact,
      short: short
    }, index))
  })]
});